const steps = [
  {
    number: '1',
    title: '内容を入力',
    description: 'サービス名や伝えたいことを、チャットで入力します。',
  },
  {
    number: '2',
    title: 'AIがLPを作成',
    description: 'AIが構成・文章・デザインをまとめて生成します。',
  },
  {
    number: '3',
    title: '確認して公開',
    description: '内容を確認して、そのまま公開できます。',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 md:py-28 px-6 md:px-10 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="section-label">使い方</span>
          <h2 className="section-title">使い方は3ステップ</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-10 left-[20%] right-[20%] h-px bg-border" />

          {steps.map((item) => (
            <div key={item.number} className="relative text-center">
              <div className="w-14 h-14 rounded-full bg-white border-2 border-primary text-primary text-xl font-bold flex items-center justify-center mx-auto mb-6 relative z-10">
                {item.number}
              </div>
              <h3 className="text-lg font-bold text-primary mb-2">{item.title}</h3>
              <p className="text-sm text-textMuted leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
